<template>
  <el-row class="container-card mt60 el-row">
    <div
      class="fixed-header flex-space-between" :style="[ showMenu ? { height: '165px' } : { height: '80px' }]"
      :class="[is_toggled ? 'toggled' : 'not-toggled']"
    >
      <div class="flex-start name">
        <el-avatar shape="square" :size="47" :src="image" @error="errorHandler">
          <img src="@/assets/images/no_image.png" />
        </el-avatar>
        <h2>{{ artist_label.name }}</h2>
      </div>
      <div class="mobile-arrow">
        <i 
          @click="showMenu = !showMenu" 
          :class="[showMenu ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
      </div>
      <div class="info-menu" :class="[showMenu ? 'toggled' : 'not-toggled']">
        <div class="menu flex-center">
          <i
            class="fas fa-chart-line"
            :class="{ active: showDashboard }"
            @click="
              ;(showDashboard = true),
                (showTracks = false),
                (showCampaigns = false),
                (showProfile = false),
                (showSubmiMusic = false)
            "
          ></i>
          <i
            class="fas fa-headphones-alt"
            :class="{ active: showTracks }"
            @click="
              ;(showTracks = true),
                (showDashboard = false),
                (showCampaigns = false),
                (showProfile = false),
                (showSubmiMusic = false)
            "
          ></i>
          <img v-if="dev === 'show'"
              class="fas fa-submit-music"
               :class="{ active: showSubmiMusic }"
               @click="
              ;(showTracks = false),
                (showDashboard = false),
                (showCampaigns = false),
                (showProfile = false),
                (showSubmiMusic = true)
            " src="@/assets/images/submit_music.svg" />
          <svg
            v-if="dev === 'phase2'"
            class="icon"
            :class="{ active: showCampaigns }"
            @click="
              ;(showCampaigns = true),
                (showDashboard = false),
                (showTracks = false),
                (showProfile = false),
                (showSubmiMusic = false)
            "
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 33.5 32.486"
          >
            <path
              id="vc_path"
              data-name="VC Icon"
              d="M22.751,79.486a16.251,16.251,0,1,1,0-32.486A16.521,16.521,0,0,1,39.5,63.243a15.684,15.684,0,0,1-1.318,6.317,16.2,
            16.2,0,0,1-3.593,5.164,16.765,16.765,0,0,1-5.325,3.485A17.052,17.052,0,0,1,22.751,79.486ZM11.025,57.5A2.134,2.134,0,
            0,0,8.9,59.53a1.82,1.82,0,0,0,.2.9l6.04,13.384a2.419,2.419,0,0,0,2.342,1.614h.166a2.448,2.448,0,0,0,2.332-1.6l1.684-3.75a9.547,
            9.547,0,0,1-2.729-3.6L17.609,69.6l-4.445-10.6A2.305,2.305,0,0,0,11.025,57.5ZM28.287,54a8.3,8.3,0,0,0-8.418,8.364,8.136,8.136,0,
            0,0,8.363,8.274,8.565,8.565,0,0,0,6.074-2.322A1.844,1.844,0,0,0,35,66.874a1.994,1.994,0,0,0-3.334-1.426,4.628,4.628,0,0,1-3.39,
            1.373,4.15,4.15,0,0,1-3.055-1.3A4.681,4.681,0,0,1,24,62.284a4.273,4.273,0,0,1,4.278-4.454,4.753,4.753,0,0,1,3.307,1.308l.083.063a2.235,
            2.235,0,0,0,1.2.357,1.948,1.948,0,0,0,1.3-3.495A8.71,8.71,0,0,0,28.287,54Z"
              transform="translate(-6 -47)"
              fill="#7b758b"
            />
          </svg>
          <i
            v-if="dev === 'phase2'"
            class="fas fa-user-circle"
            :class="{ active: showProfile }"
            @click="
              ;(showProfile = true),
                (showTracks = false),
                (showDashboard = false),
                (showCampaigns = false),
                (showSubmiMusic = false)
            "
          ></i>
        </div>
        <div class="stats flex-space-around">
          <div class="stat">
            <span class="value">{{ artist_label.previews }}</span>
            <span class="label">Previews</span>
          </div>
          <div class="stat">
            <span class="value">{{ artist_label.downloads }}</span>
            <span class="label">Downloads</span>
          </div>
          <div class="stat">
            <span class="value">{{ artist_label.tracks }}</span>
            <span class="label">Tracks</span>
          </div>
        </div>
      </div>
    </div>
    <ArtistDashboard v-if="showDashboard" />
    <ArtistTracks v-if="showTracks" />
    <ArtistCampaigns v-if="showCampaigns" />
    <ArtistProfile v-if="showProfile" />
    <SubmitMusic v-if="showSubmiMusic" />
  </el-row>
</template>

<script>
import { mapState } from 'vuex'
import ArtistDashboard from '@/modules/artist/dashboard/views/Index'
import ArtistTracks from '@/modules/artist/tracks/views/Index'
import ArtistCampaigns from '@/modules/artist/my-vidcents/views/Index'
import ArtistProfile from '@/modules/artist/my-profile/views/Index'
import SubmitMusic from '@/modules/artist/tracks/views/SubmitMusic'

export default {
  components: {
    ArtistDashboard,
    ArtistTracks,
    ArtistCampaigns,
    ArtistProfile,
    SubmitMusic
  },

  data() {
    return {
      url: process.env.VUE_APP_STORAGE_URL,
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      showDashboard: true,
      showTracks: false,
      showCampaigns: false,
      showProfile: false,
      showMenu: false,
      showSubmiMusic: false
    }
  },

  computed: {
    ...mapState('auth', ['user', 'artist', 'is_toggled']),
    ...mapState('artistDashboard', ['artist_label']),

    image() {
      if (this.artist_label && this.artist_label.file_name !== null) {
        return this.url + 'artists/' + this.artist_label.file_name
      } else {
        return null
      }
    }
  },

  methods: {
    errorHandler() {
      return true
    },

    openMenu(route) {
      return this.$router.push(route)
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-header {
  position: fixed;
  top: 90px;
  z-index: 110;
  height: 73px;
  padding: 0 20px;
  max-width: 1050px;
  width: calc(100% - 390px);
  margin-right: 2rem;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.17);
  background: white;
  border-radius: 0 0 20px 20px;
  h2 {
    font-size: 22px;
    padding-left: 10px;
  }
  .name {
    width: 34rem;
  }
  .info-menu {
    display: flex;
  }
  .mobile-arrow {
    display: none;
    cursor: pointer;
  }
  .menu {
    padding-right: 5rem;
    i,
    svg.icon {
      color: #868292;
      cursor: pointer;
      margin: 0 15px;
      &.active,
      &:hover {
        color: #d3162f;
        #vc_path {
          fill: #d3162f;
        }
      }
    }
  }
  .stats {
    .stat {
      margin: 0 10px;
    }
  }
  // &.toggled {
  //   width: calc(100% - 175px);
  // }
}
@import '@/assets/scss/_responsive.scss';
</style>
